export default () => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: 1,
  paddingY: 4,
})
